var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import { SingleConcurrentRequestController, safeReaction } from '../../common';
export const DIGITARK_IDS = ['282', '327', '37601'];
export default class FooterColumnStore {
    constructor(rootStore, columns) {
        Object.defineProperty(this, "provided", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "columns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "fetchJson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url) => {
                try {
                    return await this.controller.get(url);
                }
                catch (error) {
                }
                return null;
            }
        });
        Object.defineProperty(this, "fetchFooterColumns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url) => {
                const response = await this.fetchJson(url);
                return (response === null || response === void 0 ? void 0 : response.columns) ? response.columns : [];
            }
        });
        Object.defineProperty(this, "updateFooterItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                if (this.provided) {
                    return;
                }
                const { lang, URLData } = this.rootStore.environmentStore;
                const responseColumns = await this.fetchFooterColumns(URLData.getFooterColumnsURL(lang));
                this.setFooterState(responseColumns);
            }
        });
        Object.defineProperty(this, "setFooterState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (columns = [], provided = false) => {
                this.columns = columns;
                this.provided = provided;
            }
        });
        Object.defineProperty(this, "setProvided", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (provided = false) => {
                const shouldUpdate = this.provided && !provided;
                this.provided = provided;
                if (shouldUpdate) {
                    this.updateFooterItems();
                }
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        if (columns) {
            this.columns = columns;
            this.provided = true;
        }
        else if (!rootStore.propStateStore.isSsr) {
            this.updateFooterItems();
        }
        safeReaction(rootStore, () => this.rootStore.environmentStore.lang, () => this.updateFooterItems());
    }
}
__decorate([
    observable
], FooterColumnStore.prototype, "provided", void 0);
__decorate([
    observable
], FooterColumnStore.prototype, "columns", void 0);
__decorate([
    action
], FooterColumnStore.prototype, "setFooterState", void 0);
__decorate([
    action
], FooterColumnStore.prototype, "setProvided", void 0);
//# sourceMappingURL=FooterColumnStore.js.map